// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported, logEvent } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA5MjCxvh5feTaXQd6BlK20r4TKjX49aT4",
  authDomain: "meeza-app-45282.firebaseapp.com",
  projectId: "meeza-app-45282",
  storageBucket: "meeza-app-45282.firebasestorage.app",
  messagingSenderId: "76350137724",
  appId: "1:76350137724:web:5c79f2e2163ca681deb0f9",
  measurementId: "G-8XCMC9FZV9",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

let analytics;
isSupported().then((yes) => {
  if (yes) {
    analytics = getAnalytics(app);
    // Optional: log an install event manually
    logEvent(analytics, "app_install");
  }
});

export { app, analytics };
